export function normalizeToAsciiSnakeCase(rawValue?: string | null) {
    if (!rawValue) return "";

    const polishDiacriticsMap: Record<string, string> = {
        ą: "a",
        ć: "c",
        ę: "e",
        ł: "l",
        ń: "n",
        ó: "o",
        ś: "s",
        ż: "z",
        ź: "z"
    };

    return rawValue
        .replace(/[ąćęłńóśżź]/gi, (char) => polishDiacriticsMap[char.toLowerCase()] ?? char)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
}
export function normalizeToAsciiSnakeCase(rawValue?: string | null) {
    if (!rawValue) return "";

    const polishDiacriticsMap: Record<string, string> = {
        ą: "a",
        ć: "c",
        ę: "e",
        ł: "l",
        ń: "n",
        ó: "o",
        ś: "s",
        ż: "z",
        ź: "z"
    };

    return rawValue
        .replace(/[ąćęłńóśżź]/gi, (char) => polishDiacriticsMap[char.toLowerCase()] ?? char)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
}
